<script setup lang="ts">
  import {
    computed,
    nextTick,
    onActivated,
    onBeforeUnmount,
    onMounted,
    reactive,
    ref,
    watch,
  } from 'vue';
  import {
    actions as actionTypes,
    useUserComponent,
    userComponentProps,
    useHelpers,
    createComponentScope,
    Resource,
    uniqueID,
  } from '@integro/core';
  import type { IAppHelpers } from '@integro/core';
  import * as _ from 'lodash';

  defineOptions({
    name: 'Charts',
  });

  const componentMetadata = {
    kind: 'usercontrol',
  };

  const emit = defineEmits(['reload', 'close', 'save']);

  const props = defineProps({
    ...userComponentProps,
  });

  const {
    $app,
    $fn,
    $i18n,
    $store,
    $config,
    $imodal,
    $notification,
    $tabs,
    $route,
    $router,
    gettext,
    pgettext,
    ngettext,
    npgettext,
    schemaDefaults,
    getSchema,
    searchDataSource,
    randomElementId,
    datetime,
    date,
    time,
    number,
    money,
    distance,
    username,
    filesize,
  } = useHelpers();

  const dashboards = ref(null);
  const ux = ref([]);

  const $data = computed(() => ({
    dashboards: dashboards.value,
    ux: ux.value,
  }));

  const $$load_dashboards = () => {
    return new Promise((resolve, reject) => {
      $fn.value
        .fetch('list_superset_dashboards')
        .then((p) => resolve(p.result))
        .catch((err) => {
          resolve({
            error: {
              message: _.get(
                err,
                'response.data.message',
                err.toJSON().message
              ),
            },
          });
        });
    });
  };

  const {
    loading,
    error,
    loaded,
    reloading,
    showLoadingIndicator,
    loadDataThrottled,
    friendlyName,
    loadData,
    touchLastLoaded,
    handleError,
    setData,
    forms,
    registerForm,
    unregisterForm,
    canLoadData,
    isModalComponent,
    modalName,
    pageDocument: _pageDocument,
    routeTab,
    ux: _ux,
    componentMetadata: _componentMetadata,
    $uid,
    lastLoaded,
  } = useUserComponent(props, {
    metadata: componentMetadata,
    dataSpecs: [{ name: 'dashboards' }, { name: 'ux' }],
    loaders: { dashboards: $$load_dashboards },
    ux: {},
    dataRefs: { dashboards, ux },
  });

  const $component = createComponentScope(
    {
      $app,
      $fn,
      $i18n,
      $store,
      $imodal,
      $notification,
      $tabs,
      $router,
    } as IAppHelpers,
    {
      emit,
      forms,
      error,
      isModalComponent,
      modalName,
      componentMetadata,
      loadData,
      registerForm,
      unregisterForm,
      setData,
      touchLastLoaded,
      handleError,
    }
  );

  const actions = {};

  defineExpose({
    loadData,
    loading,
    loaded,
    error,
  });
</script>

<template>
  <BNavItemDropdown>
    <template #button-content>
      {{ pgettext('MainMenu', 'Reports') }}
    </template>
    <ItpNavItem
      v-if="dashboards && dashboards.error && dashboards.error.message"
    >
      <ItpText
        wrap
        :title="dashboards.error.message"
        :text="dashboards.error.message"
      >
      </ItpText>
    </ItpNavItem>
    <template v-for="item in dashboards">
      <ItpNavItem
        :key="item.id"
        :to="'/charts/' + item.id"
        :text="item.dashboard_title"
        dropdown-item
        v-if="_.isArray(dashboards)"
      >
      </ItpNavItem>
    </template>
  </BNavItemDropdown>
</template>
